import { render, staticRenderFns } from "./approver-py.vue?vue&type=template&id=f00c502a&scoped=true"
import script from "./approver-py.vue?vue&type=script&lang=js"
export * from "./approver-py.vue?vue&type=script&lang=js"
import style0 from "./approver-py.vue?vue&type=style&index=0&id=f00c502a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f00c502a",
  null
  
)

export default component.exports